import { useEffect, useRef, useState } from "react";

export function useDebouncedValue<T>(value: T, debounceMs = 300) {
    const [current, setCurrent] = useState(value);
    const timeoutRef = useRef<NodeJS.Timeout | undefined>(undefined);

    useEffect(() => {
        if (timeoutRef.current !== undefined) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = undefined;
        }

        timeoutRef.current = setTimeout(() => setCurrent(value), debounceMs);
    }, [debounceMs, value]);

    return current;
}
